import React from 'react';
import { createPortal } from 'react-dom';
import styles from './FullscreenOverlay.module.css';

const FullscreenOverlay = ({
  children,
}) => createPortal(
  <div className={styles.wrapper}>
    {children}
  </div>,
  document.body,
);

export { FullscreenOverlay };
